import { publicationApi } from 'apiConnector/discover';
import { SeeMorePublicationsContainer } from 'components/discover/publications/see-more/see-more-publications-container';
import { SeeMoreThematicsSkeleton } from 'components/discover/publications/see-more/skeletons/skeletons';
import { useCallback } from 'react';
import { logAnalytics } from 'shared/middlewares/analytics/logger';
import type { SgBsTheme } from 'state/userPreferences/userPreferences.model';

import { LoadingSkeleton } from './loading-skeleton';
import { PublicationContainer } from './publication-container';

interface ThematicsProps {
  enableSeeMore: boolean;
  theme: SgBsTheme;
}

export function Thematics({ enableSeeMore, theme }: ThematicsProps) {
  const trackOpen = useCallback(() => {
    logAnalytics.trackEvent('Discover', 'Open Thematic publication');
  }, []);
  const trackSlide = useCallback(() => {
    logAnalytics.trackEvent('Discover', 'Slide Thematic publication');
  }, []);
  const onSeeMore = useCallback(() => {
    logAnalytics.trackEvent('Discover', 'See more Thematic publication');
  }, []);

  return (
    <PublicationContainer
      api={publicationApi.fetchThematics}
      publishedKey="discover.thematics.published"
      errorKey="discover.thematics.error"
      soonKey="discover.thematics.soon"
      titleKey="discover.thematics.title"
      seeMoreKey="discover.thematics.seeMore"
      id="thematics"
      skeleton={<LoadingSkeleton id="thematics" hasContent={false} hasPlayButton={false} />}
      trackOpen={trackOpen}
      trackSlide={trackSlide}
      onSeeMore={onSeeMore}
      seeMoreModalContent={
        enableSeeMore
          ? onClose => (
              <SeeMorePublicationsContainer
                theme={theme}
                onClose={onClose}
                api={publicationApi.fetchMoreThematics}
                allKey="discover.thematics.all"
                titleKey="discover.thematics.title"
                skeleton={<SeeMoreThematicsSkeleton />}
                modalContentType="thematics"
              />
            )
          : undefined
      }
    />
  );
}
